export const queueConclusion = [
  {
    path: '/confirmar-chegada-unidade',
    name: 'unit-arrival',
    component: () => import('@/views/unitArrival/UnitArrival.vue'),
    meta: {
      header: {
        hideHeader: true,
        hidePreviousBtn: true,
      },
      isConclusionRoute: true,
    },
  },
];
